const Url = 'https://fj.orangeyak.xyz/api/core'
const themeDefault = 'dark'
const namesOfModes = ['dark', 'moonlight', 'eclipse', 'light']
const UrlBase = 'https://fj.orangeyak.xyz/'
const TitleCompany = 'Fischer Jordan'
const Title_NavBar = "FJ SCROLL"
const KMS = "FJ KMS"
const shortHand = "FJ"
export { Url, themeDefault, namesOfModes, Title_NavBar, KMS, shortHand, UrlBase, TitleCompany }